import React from 'react';
import { Alert } from 'react-bootstrap';
import Toolbar from '../Header/Toolbar/Toolbar';
import './Login.css';

const SessionExpired = ({ location }) => {
  const error = location.state.error || 'Session expired';
  const description = location.state.error_description || 'Please log back in';
  return (
    <div className="container text-center">
      <Toolbar />

      <div className="sessionExpiredAlert">
        <Alert bsstyle="warning">
          <strong>{error}</strong>
          <br />
          {description}
        </Alert>
      </div>
    </div>
  );
};

export default SessionExpired;



// WEBPACK FOOTER //
// ./src/components/Login/SessionExpired.js